import { OVERLAY_DEFAULT_CONFIG, OverlayDefaultConfig } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';

const matFormFieldOptions: MatFormFieldDefaultOptions = {
  appearance: 'outline',
  color: 'accent',
};

const matOverlayOptions: OverlayDefaultConfig = {
  usePopover: false,
};

@NgModule({
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: matFormFieldOptions,
    },
    {
      provide: OVERLAY_DEFAULT_CONFIG,
      useValue: matOverlayOptions,
    },
  ],
})
export class MatConstantsModule {
}
